import { render, staticRenderFns } from "./TabLoanEligible.vue?vue&type=template&id=4d2804e0"
import script from "./TabLoanEligible.vue?vue&type=script&lang=js"
export * from "./TabLoanEligible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports